export const searchStudent = (students, query) => {
    return students.filter(student =>
      student.name.toLowerCase().includes(query.toLowerCase())
    );
  };
  